import JassEnum from './enum';

/**
 * type subanimtype
 */
export default class JassSubAnimType extends JassEnum {}
